// App const
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const SET_SERVER_ERROR = 'SET_SERVER_ERROR';
export const UPDATE_QUERY = 'UPDATE_QUERY';

// Absences Module const

// active absences
export const GET_CAMPUSES_AND_ABSENCES_PENDING = 'GET_CAMPUSES_AND_ABSENCES_PENDING';
export const GET_CAMPUSES_AND_ABSENCES_FAIL = 'GET_CAMPUSES_AND_ABSENCES_FAIL';
export const GET_CAMPUSES_FOR_ABSENCES_SUCCESS = 'GET_CAMPUSES_FOR_ABSENCES_SUCCESS';
export const GET_ACTIVE_ABSENCES_PENDING = 'GET_ACTIVE_ABSENCES_PENDING';
export const GET_ACTIVE_ABSENCES_SUCCESS = 'GET_ACTIVE_ABSENCES_SUCCESS';
export const GET_ACTIVE_ABSENCES_FAIL = 'GET_ACTIVE_ABSENCES_FAIL';
export const CLEAR_ABSENCES_REDUCER = 'CLEAR_ABSENCES_REDUCER';

// Alarms Module const

// active alarms
export const CLEAR_ACTIVE_ALARMS_COUNT = 'CLEAR_ACTIVE_ALARMS_COUNT';
export const CLEAR_ALARMS_HISTORY_FILTERS = 'CLEAR_ALARMS_HISTORY_FILTERS';
export const CLEAR_ALARMS_REDUCER = 'CLEAR_ALARMS_REDUCER';
export const GET_ACTIVE_ALARMS_COUNT = 'GET_ACTIVE_ALARMS_COUNT';
export const GET_ACTIVE_ALARMS_COUNT_SUCCESS = 'GET_ACTIVE_ALARMS_COUNT_SUCCESS';
export const GET_ALARM_LIST = 'GET_ALARM_LIST';
export const GET_ALARM_LIST_ERROR = 'GET_ALARM_LIST_ERROR';
export const GET_ALARM_LIST_SUCCESS = 'GET_ALARM_LIST_SUCCESS';
export const SEND_ALARM_MESSAGE = 'SEND_ALARM_MESSAGE';
export const SEND_ALARM_MESSAGE_SUCCESS = 'SEND_ALARM_MESSAGE_SUCCESS';
export const SEND_ALARM_MESSAGE_FAILURE = 'SEND_ALARM_MESSAGE_FAILURE';
export const START_ALARM_CALL = 'START_ALARM_CALL';
export const START_ALARM_CALL_ERROR = 'START_ALARM_CALL_ERROR';
export const START_ALARM_CALL_SUCCESS = 'START_ALARM_CALL_SUCCESS';
export const STOP_ALARM_CALL = 'STOP_ALARM_CALL';
export const STOP_ALARM_CALL_ERROR = 'STOP_ALARM_CALL_ERROR';
export const STOP_ALARM_CALL_SUCCESS = 'STOP_ALARM_CALL_SUCCESS';
// alarms history
export const CLEAR_ALARMS_HISTORY_REDUCER = 'CLEAR_ALARMS_HISTORY_REDUCER';
export const CLEAR_ALARM_MESSAGES = 'CLEAR_ALARM_MESSAGES';
export const GET_ALARMS_HISTORY_LIST = 'GET_ALARMS_HISTORY_LIST';
export const GET_ALARMS_HISTORY_LIST_ERROR = 'GET_ALARMS_HISTORY_LIST_ERROR';
export const GET_ALARMS_HISTORY_LIST_SUCCESS = 'GET_ALARMS_HISTORY_LIST_SUCCESS';
export const GET_ALARMS_HISTORY_MESSAGES = 'GET_ALARMS_HISTORY_MESSAGES';
export const GET_ALARMS_HISTORY_MESSAGES_ERROR = 'GET_ALARMS_HISTORY_MESSAGES_ERROR';
export const GET_ALARMS_HISTORY_MESSAGES_SUCCESS = 'GET_ALARMS_HISTORY_MESSAGES_SUCCESS';
export const GET_ALARM_MESSAGE_LIST = 'GET_MESSAGE_LIST';
export const GET_ALARM_MESSAGE_LIST_ERROR = 'GET_ALARM_MESSAGE_LIST_ERROR';
export const GET_ALARM_MESSAGE_LIST_SUCCESS = 'GET_ALARM_MESSAGE_LIST_SUCCESS';
export const SET_ALARMS_HISTORY_FILTERS = 'SET_ALARMS_HISTORY_FILTERS,';
// calls history
export const CLEAR_CALLS_HISTORY_FILTERS = 'CLEAR_CALLS_HISTORY_FILTERS';
export const CLEAR_CALLS_HISTORY = 'CLEAR_CALLS_HISTORY';
export const SEARCH_CALLS_HISTORY = 'SEARCH_CALLS_HISTORY';
export const SEARCH_CALLS_HISTORY_FAILURE = 'SEARCH_CALLS_HISTORY_FAILURE';
export const SEARCH_CALLS_HISTORY_SUCCESS = 'SEARCH_CALLS_HISTORY_SUCCESS';
export const SET_CALLS_HISTORY_FILTERS = 'SET_CALLS_HISTORY_FILTERS';

// Customizer const
export const TOGGLE_COLLAPSED_NAV = 'TOGGLE_COLLAPSED_NAV';
export const DRAWER_TYPE = 'DRAWER_TYPE';
export const FIXED_DRAWER = 'FIXED_DRAWER';
export const COLLAPSED_DRAWER = 'COLLAPSED_DRAWER';
// `containers/index.jsx` derives the mini-drawer (80px icon strip) mode by
// ELIMINATION — it applies that class when drawerType is neither FIXED nor
// COLLAPSED — so this value is never compared against, only used to mean
// "neither of the other two". Naming it keeps call sites honest instead of
// having them pass an arbitrary string or an empty array.
export const MINI_DRAWER = 'MINI_DRAWER';
export const THEME_COLOR = 'THEME_COLOR';
export const DARK_THEME = 'DARK_THEME';
export const WINDOW_WIDTH = 'WINDOW_WIDTH';
export const SWITCH_LANGUAGE = 'SWITCH_LANGUAGE';
export const SWITCH_LANGUAGE_SUCCESS = 'SWITCH_LANGUAGE_SUCCESS';

// Contact Module const

export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';

// Auth const
export const ACCEPT_TERMS_AND_CONDITIONS = 'ACCEPT_TERMS_AND_CONDITIONS';
export const BACK_TO_IDENTIFIER_FORM = 'BACK_TO_IDENTIFIER_FORM';
export const CONFIRM_USER_SIGNUP = 'CONFIRM_USER_SIGNUP';
export const GET_CURRENT_USER = 'GET_CURRENT_USER';
export const GET_CURRENT_USER_SUCCESS = 'GET_CURRENT_USER_SUCCESS';
export const ENTER_TEMPORARY_PASSWORD = 'ENTER_TEMPORARY_PASSWORD';
export const SHOW_AUTH_VALIDATION_ERROR_MESSAGE = 'SHOW_AUTH_VALIDATION_ERROR_MESSAGE';
export const SHOW_TERMS_AND_CONDITIONS = 'SHOW_TERMS_AND_CONDITIONS';
export const SIGNUP_USER = 'SIGNUP_USER';
export const SIGNUP_USER_SUCCESS = 'SIGNUP_USER_SUCCESS';
export const SIGNIN_USER = 'SIGNIN_USER';
export const SIGNIN_USER_SUCCESS = 'SIGNIN_USER_SUCCESS';
export const DROP_SESSION = 'DROP_SESSION';
export const SIGNOUT_USER = 'SIGNOUT_USER';
export const SIGNOUT_USER_SUCCESS = 'SIGNOUT_USER_SUCCESS';
export const CLEAR_PROFILE_TEMP_DATA = 'CLEAR_PROFILE_TEMP_DATA';
export const SUBMIT_TEMPORARY_PASSWORD = 'SUBMIT_TEMPORARY_PASSWORD';
export const VERIFY_USER = 'VERIFY_USER';
export const VERIFY_USER_SUCCESS = 'VERIFY_USER_SUCCESS';
export const VERIFY_USER_SIGNUP = 'VERIFY_USER_SIGNUP';
export const VERIFY_USER_SIGNUP_SUCCESS = 'VERIFY_USER_SIGNUP_SUCCESS';
export const INIT_URL = 'INIT_URL';
export const RESET_ALL_AUTH_ERROR_MESSAGES = 'RESET_ALL_AUTH_ERROR_MESSAGES';
export const RESET_AUTH_ERROR_MESSAGE = 'RESET_AUTH_ERROR_MESSAGE';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const SET_NEW_PASSWORD = 'SET_NEW_PASSWORD';

// User profile consts

export const GET_PROFILE_SETTINGS = 'GET_PROFILE_SETTINGS';
export const GET_PROFILE_SETTINGS_SUCCESS = 'GET_PROFILE_SETTINGS_SUCCESS';
export const SET_PROFILE_SETTINGS_LOADING = 'GET_PROFILE_SETTINGS_LOADING';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR';
export const CHANGE_PERMISSIONS = 'CHANGE_PERMISSIONS';
export const CHANGE_PERMISSIONS_SUCCESS = 'CHANGE_PERMISSIONS_SUCCESS';

// Chat Module const

export const ON_SHOW_LOADER = 'on_show_loader';
export const ON_HIDE_LOADER = 'on_hide_loader';

// Pupils Module const

export const CLEAR_FETCHED_PUPILS = 'CLEAR_FETCHED_PUPILS';
export const SEARCH_PUPILS = 'SEARCH_PUPILS';
export const SEARCH_PUPILS_FOR_EVENT = 'SEARCH_PUPILS_FOR_EVENT';
export const SEARCH_PUPILS_FAILURE = 'SEARCH_PUPILS_FAILURE';
export const SEARCH_PUPILS_SUCCESS = 'SEARCH_PUPILS_SUCCESS';
export const GET_PUPILS_DELIVERY_LOCATION = 'GET_PUPILS_DELIVERY_LOCATION';
export const GET_PUPILS_DELIVERY_LOCATION_SUCCESS = 'GET_PUPILS_DELIVERY_LOCATION_SUCCESS';

// staff module
export const CLEAR_FETCHED_STAFF = 'CLEAR_FETCHED_STAFF';
export const SEARCH_STAFF = 'SEARCH_STAFF';
export const SEARCH_STAFF_FAILURE = 'SEARCH_STAFF_FAILURE';
export const SEARCH_STAFF_SUCCESS = 'SEARCH_STAFF_SUCCESS';

// Notice templates Module const

export const ADD_NOTICE_TEMPLATE = 'ADD_NOTICE_TEMPLATE';
export const ADD_NOTICE_TEMPLATE_SUCCESS = 'ADD_NOTICE_TEMPLATE_SUCCESS';
export const DELETE_NOTICE_TEMPLATE = 'DELETE_NOTICE_TEMPLATE';
export const DELETE_NOTICE_TEMPLATE_SUCCESS = 'DELETE_NOTICE_TEMPLATE_SUCCESS';
export const EDIT_NOTICE_TEMPLATE = 'EDIT_NOTICE_TEMPLATE';
export const EDIT_NOTICE_TEMPLATE_SUCCESS = 'EDIT_NOTICE_TEMPLATE_SUCCESS';
export const GET_NOTICE_TEMPLATE_BY_ID = 'GET_NOTICE_TEMPLATE_BY_ID';
export const GET_NOTICE_TEMPLATE_BY_ID_FAILURE = 'GET_NOTICE_TEMPLATE_BY_ID_FAILURE';
export const GET_NOTICE_TEMPLATE_BY_ID_SUCCESS = 'GET_NOTICE_TEMPLATE_BY_ID_SUCCESS';
export const GET_NOTICE_TEMPLATES = 'GET_NOTICE_TEMPLATES';
export const GET_NOTICE_TEMPLATES_SUCCESS = 'GET_NOTICE_TEMPLATES_SUCCESS';
export const GET_NOTICE_TEMPLATES_FAILURE = 'GET_NOTICE_TEMPLATES_FAILURE';
export const GET_MORE_NOTICE_TEMPLATES_SUCCESS = 'GET_MORE_NOTICE_TEMPLATES_SUCCESS';
export const HIDE_NOTICE_TEMPLATES_LOADER = 'HIDE_NOTICE_TEMPLATES_LOADER';
export const SHOW_NOTICE_TEMPLATES_LOADER = 'SHOW_NOTICE_TEMPLATES_LOADER';
export const CLEAR_NOTICE_TEMPLATES_REDUCER = 'CLEAR_NOTICE_TEMPLATES_REDUCER';

// Notices consts

export const SEND_NOTICE = 'SEND_NOTICE';
export const GET_NOTICES = 'GET_NOTICES';
export const GET_NOTICES_SUCCESS = 'GET_NOTICES_SUCCESS';
export const SEND_NOTICE_SUCCESS = 'SEND_NOTICE_SUCCESS';
export const SEND_NOTICE_FAILURE = 'SEND_NOTICE_FAILURE';
export const GET_NOTICES_NEW_LIST_SUCCESS = 'GET_NOTICES_NEW_LIST_SUCCESS';
export const GET_NOTICE_BY_ID = 'GET_NOTICE_BY_ID';
export const GET_NOTICE_BY_ID_SUCCESS = 'GET_NOTICE_BY_ID_SUCCESS';
export const GET_NOTICE_DELIVERY_STATUS = 'GET_NOTICE_DELIVERY_STATUS';
export const GET_NOTICE_DELIVERY_STATUS_SUCCESS = 'GET_NOTICE_DELIVERY_STATUS_SUCCESS';
export const CLEAR_NOTICE_DELIVERY_STATUS = 'CLEAR_NOTICE_DELIVERY_STATUS';
export const GET_UNREAD_NOTICES = 'GET_UNREAD_NOTICES';
export const GET_UNREAD_NOTICES_SUCCESS = 'GET_UNREAD_NOTICES_SUCCESS';
export const HIDE_NOTICES_DETAILS_LOADER = 'HIDE_NOTICES_DETAILS_LOADER';
export const SHOW_NOTICES_DETAILS_LOADER = 'SHOW_NOTICES_DETAILS_LOADER';
export const HIDE_NOTICES_LOADER = 'HIDE_NOTICES_LOADER';
export const SHOW_NOTICES_LOADER = 'SHOW_NOTICES_LOADER';
export const CLEAR_NOTICES_REDUCER = 'CLEAR_NOTICES_REDUCER';
export const CLEAR_NOTICES_UNREAD_COUNT = 'CLEAR_NOTICES_UNREAD_COUNT';
export const SEND_NOTICE_RESPONSE = 'SEND_NOTICE_RESPONSE';
export const SEND_NOTICE_RESPONSE_SUCCESS = 'SEND_NOTICE_RESPONSE_SUCCESS';
export const GET_NOTICES_HISTORY = 'GET_NOTICES_HISTORY';
export const GET_NOTICE_HISTORY_BY_ID = 'GET_NOTICE_HISTORY_BY_ID';
export const GET_NOTICE_HISTORY_DELIVERY_STATUS = 'GET_NOTICE_HISTORY_DELIVERY_STATUS';
export const SET_NOTICES_HISTORY_FILTERS = 'SET_NOTICES_HISTORY_FILTERS';
export const SET_SELECTED_NOTICE = 'SET_SELECTED_NOTICE';

// filter based notifications
export const CREATE_NOTIFICATION_WITH_FILTERS = 'CREATE_NOTIFICATION_WITH_FILTERS';
export const CREATE_NOTIFICATION_WITH_FILTERS_SUCCESS = 'CREATE_NOTIFICATION_WITH_FILTERS_SUCCESS';
export const CREATE_NOTIFICATION_WITH_FILTERS_FAILURE = 'CREATE_NOTIFICATION_WITH_FILTERS_FAILURE';
export const GET_NOTIFICATION_TARGETS = 'GET_NOTIFICATION_TARGETS';
export const GET_NOTIFICATION_TARGETS_SUCCESS = 'GET_NOTIFICATION_TARGETS_SUCCESS';
export const GET_NOTIFICATION_TARGETS_FAILURE = 'GET_NOTIFICATION_TARGETS_FAILURE';
export const GET_NOTIFICATION_FILTER_OPTIONS = 'GET_NOTIFICATION_FILTER_OPTIONS';
export const GET_NOTIFICATION_FILTER_OPTIONS_SUCCESS = 'GET_NOTIFICATION_FILTER_OPTIONS_SUCCESS';
export const GET_NOTIFICATION_FILTER_OPTIONS_FAILURE = 'GET_NOTIFICATION_FILTER_OPTIONS_FAILURE';
export const GET_NOTIFICATION_RECEIVERS = 'GET_NOTIFICATION_RECEIVERS';
export const GET_NOTIFICATION_RECEIVERS_SUCCESS = 'GET_NOTIFICATION_RECEIVERS_SUCCESS';
export const GET_NOTIFICATION_RECEIVERS_FAILURE = 'GET_NOTIFICATION_RECEIVERS_FAILURE';

// Routes Module const

export const CLEAR_ROUTES_REDUCER = 'CLEAR_ROUTES_REDUCER';
export const GET_ACTIVE_ROUTE_DETAILS = 'GET_ACTIVE_ROUTE_DETAILS';
export const GET_ACTIVE_ROUTE_DETAILS_FAILED = 'GET_ACTIVE_ROUTE_DETAILS_FAILED';
export const GET_ACTIVE_ROUTE_DETAILS_SUCCESS = 'GET_ACTIVE_ROUTE_DETAILS_SUCCESS';
export const GET_INACTIVE_ROUTE_DETAILS = 'GET_INACTIVE_ROUTE_DETAILS';
export const GET_INACTIVE_ROUTE_DETAILS_FAILED = 'GET_INACTIVE_ROUTE_DETAILS_FAILED';
export const GET_INACTIVE_ROUTE_DETAILS_SUCCESS = 'GET_INACTIVE_ROUTE_DETAILS_SUCCESS';
export const GET_ACTIVE_ROUTE_DETAILS_INFO = 'GET_ACTIVE_ROUTE_DETAILS_INFO';
export const GET_ACTIVE_ROUTE_DETAILS_INFO_SUCCESS = 'GET_ACTIVE_ROUTE_DETAILS_INFO_SUCCESS';
export const GET_ACTIVE_ROUTES_HISTORY = 'GET_ACTIVE_ROUTES_HISTORY';
export const GET_ACTIVE_ROUTES_HISTORY_SUCCESS = 'GET_ACTIVE_ROUTES_HISTORY_SUCCESS';
export const GET_BUS_ROUTES = 'GET_BUS_ROUTES';
export const GET_BUS_ROUTES_SUCCESS = 'GET_BUS_ROUTES_SUCCESS';
export const GET_DETAILED_ACTIVE_ROUTE_HISTORY = 'GET_DETAILED_ACTIVE_ROUTE_HISTORY';
export const GET_DETAILED_ACTIVE_ROUTE_HISTORY_FAILURE =
  'GET_DETAILED_ACTIVE_ROUTE_HISTORY_FAILURE';
export const GET_DETAILED_ACTIVE_ROUTE_HISTORY_SUCCESS =
  'GET_DETAILED_ACTIVE_ROUTE_HISTORY_SUCCESS';
export const GET_DRIVER_ROUTES = 'GET_DRIVER_ROUTES';
export const GET_DRIVER_ROUTES_SUCCESS = 'GET_DRIVER_ROUTES_SUCCESS';
export const GET_ROUTE_BY_ID = 'GET_ROUTE_BY_ID';
export const GET_ROUTE_BY_ID_FAILURE = 'GET_ROUTE_BY_ID_FAILURE';
export const GET_ROUTE_BY_ID_SUCCESS = 'GET_ROUTE_BY_ID_SUCCESS';
export const GET_CAMPUSES_FOR_ROUTES = 'GET_CAMPUSES_FOR_ROUTES';
export const GET_CAMPUSES_FOR_ROUTES_SUCCESS = 'GET_CAMPUSES_FOR_ROUTES_SUCCESS';
export const GET_CAMPUSES_FOR_ROUTES_FAILURE = 'GET_CAMPUSES_FOR_ROUTES_FAILURE';
export const CLEAR_CAMPUSES_FOR_ROUTES = 'CLEAR_CAMPUSES_FOR_ROUTES';
export const CLEAR_ROUTE_BY_ID = 'CLEAR_ROUTE_BY_ID';
export const GET_ROUTE_HISTORY_STATIONS_STATS = 'GET_ROUTE_HISTORY_STATIONS_STATS';
export const GET_ROUTE_HISTORY_STATIONS_STATS_FAILURE = 'GET_ROUTE_HISTORY_STATIONS_STATS_FAILURE';
export const GET_ROUTE_HISTORY_STATIONS_STATS_SUCCESS = 'GET_ROUTE_HISTORY_STATIONS_STATS_SUCCESS';
export const GET_ROUTE_HISTORY_STUDENTS_STATS = 'GET_ROUTE_HISTORY_STUDENTS_STATS';
export const GET_ROUTE_HISTORY_STUDENTS_STATS_FAILURE = 'GET_ROUTE_HISTORY_STUDENTS_STATS_FAILURE';
export const GET_ROUTE_HISTORY_STUDENTS_STATS_SUCCESS = 'GET_ROUTE_HISTORY_STUDENTS_STATS_SUCCESS';
export const GET_TODAY_ROUTES = 'GET_TODAY_ROUTES';
export const GET_TODAY_ROUTES_THROTTLE = 'GET_TODAY_ROUTES_THROTTLE';
export const GET_TODAY_ROUTES_SUCCESS = 'GET_TODAY_ROUTES_SUCCESS';
export const HIDE_ROUTES_HISTORY_LOADER = 'HIDE_ROUTES_HISTORY_LOADER';
export const UPDATE_SELECTED_ROUTES = 'UPDATE_SELECTED_ROUTES';

export const GET_LOG_ROUTE_DATA = 'GET_LOG_ROUTE_DATA';
export const GET_LOG_ROUTE_DATA_SUCCESS = 'GET_LOG_ROUTE_DATA_SUCCESS';
export const GET_LOG_ROUTE_DATA_FAILURE = 'GET_LOG_ROUTE_DATA_FAILURE';
export const GET_MAP_ROUTE_DATA_SUCCESS = 'GET_MAP_ROUTE_DATA_SUCCESS';
export const GET_ROUTE_STOP_DATA = 'GET_ROUTE_STOP_DATA';
export const GET_ROUTE_STOP_DATA_SUCCESS = 'GET_ROUTE_STOP_DATA_SUCCESS';
export const GET_ROUTE_STOP_DATA_FAILURE = 'GET_ROUTE_STOP_DATA_FAILURE';
export const SEARCH_ACTIVE_ROUTE_DELAYS_HISTORY = 'SEARCH_ACTIVE_ROUTE_DELAYS_HISTORY';
export const SEARCH_ACTIVE_ROUTE_DELAYS_HISTORY_FAILURE =
  'SEARCH_ACTIVE_ROUTE_DELAYS_HISTORY_FAILURE';
export const SEARCH_ACTIVE_ROUTE_DELAYS_HISTORY_SUCCESS =
  'SEARCH_ACTIVE_ROUTE_DELAYS_HISTORY_SUCCESS';
export const SEARCH_ACTIVE_ROUTE_LOCATIONS_HISTORY = 'SEARCH_ACTIVE_ROUTE_LOCATIONS_HISTORY';
export const SEARCH_ACTIVE_ROUTE_LOCATIONS_HISTORY_FAILURE =
  'SEARCH_ACTIVE_ROUTE_LOCATIONS_HISTORY_FAILURE';
export const SEARCH_ACTIVE_ROUTE_LOCATIONS_HISTORY_SUCCESS =
  'SEARCH_ACTIVE_ROUTE_LOCATIONS_HISTORY_SUCCESS';
export const ACTIVE_ROUTE_LOCATION_HISTORY = 'ACTIVE_ROUTE_LOCATION_HISTORY';
export const ACTIVE_ROUTE_LOCATION_HISTORY_FAILURE = 'ACTIVE_ROUTE_LOCATION_HISTORY_FAILURE';
export const ACTIVE_ROUTE_LOCATION_HISTORY_SUCCESS = 'ACTIVE_ROUTE_LOCATION_HISTORY_SUCCESS';
export const SEARCH_ACTIVE_ROUTE_STATIONS_HISTORY = 'SEARCH_ACTIVE_ROUTE_STATIONS_HISTORY';
export const SEARCH_ACTIVE_ROUTE_STATIONS_HISTORY_FAILURE =
  'SEARCH_ACTIVE_ROUTE_STATIONS_HISTORY_FAILURE';
export const SEARCH_ACTIVE_ROUTE_STATIONS_HISTORY_SUCCESS =
  'SEARCH_ACTIVE_ROUTE_STATIONS_HISTORY_SUCCESS';
export const SEARCH_ACTIVE_ROUTE_STUDENTS_HISTORY = 'SEARCH_ACTIVE_ROUTE_STUDENTS_HISTORY';
export const SEARCH_ACTIVE_ROUTE_STUDENTS_HISTORY_FAILURE =
  'SEARCH_ACTIVE_ROUTE_STUDENTS_HISTORY_FAILURE';
export const SEARCH_ACTIVE_ROUTE_STUDENTS_HISTORY_SUCCESS =
  'SEARCH_ACTIVE_ROUTE_STUDENTS_HISTORY_SUCCESS';
export const SET_BUS_ROUTES_LOADING = 'SET_BUS_ROUTES_LOADING';
export const SET_DRIVER_ROUTES_LOADING = 'SET_DRIVER_ROUTES_LOADING';
export const SET_ROUTE_HISTORY_DELAYS_LOADER = 'SET_ROUTE_HISTORY_DELAYS_LOADER';
export const SET_ROUTE_HISTORY_DETAILS_LOADER = 'SET_ROUTE_HISTORY_DETAILS_LOADER';
export const SET_ROUTE_HISTORY_LOCATIONS_LOADER = 'SET_ROUTE_HISTORY_LOCATIONS_LOADER';
export const SET_ROUTE_HISTORY_STATIONS_LOADER = 'SET_ROUTE_HISTORY_STATIONS_LOADER';
export const SET_ROUTE_HISTORY_STUDENTS_LOADER = 'SET_ROUTE_HISTORY_STUDENTS_LOADER';
export const SET_ROUTES_LOADING = 'SET_ROUTES_LOADING';
export const SHOW_ROUTES_HISTORY_LOADER = 'SHOW_ROUTES_HISTORY_LOADER';
export const TERMINATE_ACTIVE_ROUTE_TOGGLE_CONFIRMATION_MODAL =
  'TERMINATE_ACTIVE_ROUTE_SHOW_CONFIRMATION_MODAL';
export const TERMINATE_ACTIVE_ROUTE_CONFIRM = 'TERMINATE_ACTIVE_ROUTE_CONFIRM';
export const TERMINATE_ACTIVE_ROUTE_SUCCESS = 'TERMINATE_ACTIVE_ROUTE_SUCCESS';
export const TERMINATE_ACTIVE_ROUTE_FAILED = 'TERMINATE_ACTIVE_ROUTE_FAILED';

// Manage route

export const CREATE_NEW_ROUTE = 'CREATE_NEW_ROUTE';
export const CREATE_NEW_ROUTE_STATION = 'CREATE_NEW_ROUTE_STATION';
export const CREATE_NEW_ROUTE_SUCCESS = 'CREATE_NEW_ROUTE_SUCCESS';
export const DELETE_ROUTE = 'DELETE_ROUTE';
export const DELETE_ROUTE_SUCCESS = 'DELETE_ROUTE_SUCCESS';
export const DELETE_ROUTE_STATION = 'DELETE_ROUTE_STATION';
export const EDIT_ROUTE = 'EDIT_ROUTE';
export const EDIT_ROUTE_SUCCESS = 'EDIT_ROUTE_SUCCESS';
export const COPY_ROUTE = 'COPY_ROUTE';
export const COPY_ROUTE_SUCCESS = 'COPY_ROUTE_SUCCESS';
export const GET_ROUTE_CARRIERS_RELATIONS = 'GET_ROUTE_CARRIERS_RELATIONS';
export const GET_ROUTE_CARRIERS_RELATIONS_SUCCESS = 'GET_ROUTE_CARRIERS_RELATIONS_SUCCESS';
export const HIDE_ROUTE_LOADER = 'HIDE_ROUTE_LOADER';
export const HIDE_ROUTE_STATIONS_LOADER = 'HIDE_ROUTE_STATIONS_LOADER';
export const REFLECT_STATIONS = 'REFLECT_STATIONS';
export const REMOVE_STATIONS_BY_DIRECTION = 'REMOVE_STATIONS_BY_DIRECTION';
export const SEARCH_ROUTES = 'SEARCH_ROUTES';
export const SEARCH_ROUTES_SUCCESS = 'SEARCH_ROUTES_SUCCESS';
export const SELECT_ROUTE_IN_MANAGE_ROUTES_PAGE = 'SELECT_ROUTE_IN_MANAGE_ROUTES_PAGE';
export const SET_COMMON_ROUTE_SCHEDULE = 'SET_COMMON_ROUTE_SCHEDULE';
export const SHOW_ROUTE_STATIONS_LOADER = 'SHOW_ROUTE_STATIONS_LOADER';
export const UPDATE_EXISTING_SEARCH_ROUTES = 'UPDATE_EXISTING_SEARCH_ROUTES';
export const UPDATE_RECENTLY_ADDED_ROUTE = 'UPDATE_RECENTLY_ADDED_ROUTE';
export const UPDATE_STATION = 'UPDATE_STATION';
export const UPDATE_STATIONS_SCHEDULE = 'UPDATE_STATIONS_SCHEDULE';
export const UPDATE_STATION_ORDER = 'UPDATE_STATION_ORDER';
export const UPDATE_STATION_SUCCESS = 'UPDATE_STATION_SUCCESS';
export const UPDATE_STATION_FAILURE = 'UPDATE_STATION_FAILURE';
export const TOGGLE_STATION_MODAL = 'TOGGLE_STATION_MODAL';
export const UPDATE_ROUTE_RELATIONS = 'UPDATE_ROUTE_RELATIONS';
export const UPDATE_ROUTE_RELATIONS_SUCCESS = 'UPDATE_ROUTE_RELATIONS_SUCCESS';
export const UPDATE_ROUTE_RELATIONS_FAILURE = 'UPDATE_ROUTE_RELATIONS_FAILURE';

export const FETCH_ALL_ROUTES_PAGINATED = 'FETCH_ALL_ROUTES_PAGINATED';
export const FETCH_ALL_ROUTES_PAGINATED_SUCCESS = 'FETCH_ALL_ROUTES_PAGINATED_SUCCESS';
export const FETCH_ALL_ROUTES_PAGINATED_FAILURE = 'FETCH_ALL_ROUTES_PAGINATED_FAILURE';

export const ECA_CREATE_PROGRAM = 'ECA_CREATE_PROGRAM';
export const ECA_CREATE_PROGRAM_SUCCESS = 'ECA_CREATE_PROGRAM_SUCCESS';
export const ECA_CREATE_PROGRAM_FAILURE = 'ECA_CREATE_PROGRAM_FAILURE';
export const ECA_PROGRAM_DETAILS = 'ECA_PROGRAM_DETAILS';
export const ECA_PROGRAM_DETAILS_SUCCESS = 'ECA_PROGRAM_DETAILS_SUCCESS';
export const ECA_PROGRAM_DETAILS_FAILURE = 'ECA_PROGRAM_DETAILS_FAILURE';
export const ECA_LIST_PROGRAMS = 'ECA_LIST_PROGRAMS';
export const ECA_LIST_PROGRAMS_SUCCESS = 'ECA_LIST_PROGRAMS_SUCCESS';
export const ECA_LIST_PROGRAMS_FAILURE = 'ECA_LIST_PROGRAMS_FAILURE';
export const ECA_UPDATE_PROGRAM = 'ECA_UPDATE_PROGRAM';
export const ECA_UPDATE_PROGRAM_SUCCESS = 'ECA_UPDATE_PROGRAM_SUCCESS';
export const ECA_UPDATE_PROGRAM_FAILURE = 'ECA_UPDATE_PROGRAM_FAILURE';
export const ECA_DELETE_PROGRAM = 'ECA_DELETE_PROGRAM';
export const ECA_DELETE_PROGRAM_SUCCESS = 'ECA_DELETE_PROGRAM_SUCCESS';
export const ECA_DELETE_PROGRAM_FAILURE = 'ECA_DELETE_PROGRAM_FAILURE';

export const ECA_CREATE_ACTIVITY = 'ECA_CREATE_ACTIVITY';
export const ECA_CREATE_ACTIVITY_SUCCESS = 'ECA_CREATE_ACTIVITY_SUCCESS';
export const ECA_CREATE_ACTIVITY_FAILURE = 'ECA_CREATE_ACTIVITY_FAILURE';
export const ECA_ACTIVITY_DETAILS = 'ECA_ACTIVITY_DETAILS';
export const ECA_ACTIVITY_DETAILS_SUCCESS = 'ECA_ACTIVITY_DETAILS_SUCCESS';
export const ECA_ACTIVITY_DETAILS_FAILURE = 'ECA_ACTIVITY_DETAILS_FAILURE';
export const ECA_ACTIVITY_EVENTS_PARTICIPANTS = 'ECA_ACTIVITY_EVENTS_PARTICIPANTS';
export const ECA_ACTIVITY_EVENTS_PARTICIPANTS_SUCCESS = 'ECA_ACTIVITY_EVENTS_PARTICIPANTS_SUCCESS';
export const ECA_ACTIVITY_EVENTS_PARTICIPANTS_FAILURE = 'ECA_ACTIVITY_EVENTS_PARTICIPANTS_FAILURE';
export const ECA_CLEAR_ACTIVITY_EVENTS_PARTICIPANTS = 'ECA_CLEAR_ACTIVITY_EVENTS_PARTICIPANTS';
export const ECA_LIST_ACTIVITIES = 'ECA_LIST_ACTIVITIES';
export const ECA_LIST_ACTIVITIES_SUCCESS = 'ECA_LIST_ACTIVITIES_SUCCESS';
export const ECA_LIST_ACTIVITIES_FAILURE = 'ECA_LIST_ACTIVITIES_FAILURE';
export const ECA_UPDATE_ACTIVITY = 'ECA_UPDATE_ACTIVITY';
export const ECA_UPDATE_ACTIVITY_SUCCESS = 'ECA_UPDATE_ACTIVITY_SUCCESS';
export const ECA_UPDATE_ACTIVITY_FAILURE = 'ECA_UPDATE_ACTIVITY_FAILURE';
export const ECA_DELETE_ACTIVITY = 'ECA_DELETE_ACTIVITY';
export const ECA_DELETE_ACTIVITY_SUCCESS = 'ECA_DELETE_ACTIVITY_SUCCESS';
export const ECA_DELETE_ACTIVITY_FAILURE = 'ECA_DELETE_ACTIVITY_FAILURE';

export const ECA_ADD_ACTIVITY_PARTICIPANTS = 'ECA_ADD_ACTIVITY_PARTICIPANTS';
export const ECA_ADD_ACTIVITY_PARTICIPANTS_SUCCESS = 'ECA_ADD_ACTIVITY_PARTICIPANTS_SUCCESS';
export const ECA_ADD_ACTIVITY_PARTICIPANTS_FAILURE = 'ECA_ADD_ACTIVITY_PARTICIPANTS_FAILURE';
export const ECA_DELETE_ACTIVITY_PARTICIPANTS = 'ECA_DELETE_ACTIVITY_PARTICIPANTS';
export const ECA_DELETE_ACTIVITY_PARTICIPANTS_SUCCESS = 'ECA_DELETE_ACTIVITY_PARTICIPANTS_SUCCESS';
export const ECA_DELETE_ACTIVITY_PARTICIPANTS_FAILURE = 'ECA_DELETE_ACTIVITY_PARTICIPANTS_FAILURE';
export const ECA_ADD_ACTIVITY_LEADS = 'ECA_ADD_ACTIVITY_LEADS';
export const ECA_ADD_ACTIVITY_LEADS_SUCCESS = 'ECA_ADD_ACTIVITY_LEADS_SUCCESS';
export const ECA_ADD_ACTIVITY_LEADS_FAILURE = 'ECA_ADD_ACTIVITY_LEADS_FAILURE';
export const ECA_DELETE_ACTIVITY_LEADS = 'ECA_DELETE_ACTIVITY_LEADS';
export const ECA_DELETE_ACTIVITY_LEADS_SUCCESS = 'ECA_DELETE_ACTIVITY_LEADS_SUCCESS';
export const ECA_DELETE_ACTIVITY_LEADS_FAILURE = 'ECA_DELETE_ACTIVITY_LEADS_FAILURE';
export const ECA_FETCH_AND_SHOW_ACTIVITY_LEADS = 'ECA_FETCH_AND_SHOW_ACTIVITY_LEADS';
export const ECA_FETCH_AND_SHOW_ACTIVITY_LEADS_SUCCESS =
  'ECA_FETCH_AND_SHOW_ACTIVITY_LEADS_SUCCESS';
export const ECA_HIDE_AND_CLEAR_ACTIVITY_LEADS = 'ECA_HIDE_AND_CLEAR_ACTIVITY_LEADS';

export const ECA_CREATE_EVENT = 'ECA_CREATE_EVENT';
export const ECA_CREATE_EVENT_SUCCESS = 'ECA_CREATE_EVENT_SUCCESS';
export const ECA_CREATE_EVENT_FAILURE = 'ECA_CREATE_EVENT_FAILURE';
export const ECA_EVENT_DETAILS = 'ECA_EVENT_DETAILS';
export const ECA_EVENT_DETAILS_SUCCESS = 'ECA_EVENT_DETAILS_SUCCESS';
export const ECA_EVENT_DETAILS_FAILURE = 'ECA_EVENT_DETAILS_FAILURE';
export const ECA_LIST_EVENTS = 'ECA_LIST_EVENTS';
export const ECA_LIST_EVENTS_SUCCESS = 'ECA_LIST_EVENTS_SUCCESS';
export const ECA_LIST_EVENTS_FAILURE = 'ECA_LIST_EVENTS_FAILURE';
export const ECA_UPDATE_EVENT = 'ECA_UPDATE_EVENT';
export const ECA_UPDATE_EVENT_SUCCESS = 'ECA_UPDATE_EVENT_SUCCESS';
export const ECA_UPDATE_EVENT_FAILURE = 'ECA_UPDATE_EVENT_FAILURE';
export const ECA_DELETE_EVENT = 'ECA_DELETE_EVENT';
export const ECA_DELETE_EVENT_SUCCESS = 'ECA_DELETE_EVENT_SUCCESS';
export const ECA_DELETE_EVENT_FAILURE = 'ECA_DELETE_EVENT_FAILURE';
export const ECA_ADD_EVENT_PARTICIPANTS = 'ECA_ADD_EVENT_PARTICIPANTS';
export const ECA_ADD_EVENT_PARTICIPANTS_SUCCESS = 'ECA_ADD_EVENT_PARTICIPANTS_SUCCESS';
export const ECA_ADD_EVENT_PARTICIPANTS_FAILURE = 'ECA_ADD_EVENT_PARTICIPANTS_FAILURE';
export const ECA_DELETE_EVENT_PARTICIPANTS = 'ECA_DELETE_EVENT_PARTICIPANTS';
export const ECA_DELETE_EVENT_PARTICIPANTS_SUCCESS = 'ECA_DELETE_EVENT_PARTICIPANTS_SUCCESS';
export const ECA_DELETE_EVENT_PARTICIPANTS_FAILURE = 'ECA_DELETE_EVENT_PARTICIPANTS_FAILURE';
export const ECA_ADD_EVENT_COORDINATORS = 'ECA_ADD_EVENT_COORDINATORS';
export const ECA_ADD_EVENT_COORDINATORS_SUCCESS = 'ECA_ADD_EVENT_COORDINATORS_SUCCESS';
export const ECA_ADD_EVENT_COORDINATORS_FAILURE = 'ECA_ADD_EVENT_COORDINATORS_FAILURE';
export const ECA_DELETE_EVENT_COORDINATORS = 'ECA_DELETE_EVENT_COORDINATORS';
export const ECA_DELETE_EVENT_COORDINATORS_SUCCESS = 'ECA_DELETE_EVENT_COORDINATORS_SUCCESS';
export const ECA_DELETE_EVENT_COORDINATORS_FAILURE = 'ECA_DELETE_EVENT_COORDINATORS_FAILURE';
export const ECA_FETCH_AND_SHOW_EVENT_COORDINATORS = 'ECA_FETCH_AND_SHOW_EVENT_COORDINATORS';
export const ECA_FETCH_AND_SHOW_EVENT_COORDINATORS_SUCCESS =
  'ECA_FETCH_AND_SHOW_EVENT_COORDINATORS_SUCCESS';
export const ECA_HIDE_AND_CLEAR_EVENT_COORDINATORS = 'ECA_HIDE_AND_CLEAR_EVENT_COORDINATORS';
export const ECA_TODAY_EVENTS = 'ECA_TODAY_EVENTS';
export const ECA_TODAY_EVENTS_SUCCESS = 'ECA_TODAY_EVENTS_SUCCESS';
export const ECA_TODAY_EVENTS_FAILURE = 'ECA_TODAY_EVENTS_FAILURE';

export const ECA_SEARCH_EVENTS_BY_PARTICPANTS = 'ECA_SEARCH_EVENTS_BY_PARTICPANTS';
export const ECA_SEARCH_EVENTS_BY_PARTICPANTS_SUCCESS = 'ECA_SEARCH_EVENTS_BY_PARTICPANTS_SUCCESS';
export const ECA_SEARCH_EVENTS_BY_PARTICPANTS_FAILURE = 'ECA_SEARCH_EVENTS_BY_PARTICPANTS_FAILURE';
export const CLEAR_FETCHED_EVENTS = 'CLEAR_FETCHED_EVENTS';

export const ECA_UPDATE_PARTICIPANT_NEXT = 'ECA_UPDATE_PARTICIPANT_NEXT';

// ECA History
export const GET_EVENTS_HISTORY = 'GET_EVENTS_HISTORY';
export const GET_EVENTS_HISTORY_SUCCESS = 'GET_EVENTS_HISTORY_SUCCESS';
export const GET_EVENTS_HISTORY_FAILURE = 'GET_EVENTS_HISTORY_FAILURE';
export const SHOW_EVENTS_HISTORY_LOADER = 'SHOW_EVENTS_HISTORY_LOADER';
export const HIDE_EVENTS_HISTORY_LOADER = 'HIDE_EVENTS_HISTORY_LOADER';
export const GET_EVENT_HISTORY_TABS = 'GET_EVENT_HISTORY_TABS';
export const GET_EVENT_HISTORY_TABS_SUCCESS = 'GET_EVENT_HISTORY_TABS_SUCCESS';
export const GET_EVENT_HISTORY_TABS_FAILURE = 'GET_EVENT_HISTORY_TABS_FAILURE';
export const GET_EVENT_HISTORY_TAB_DATA = 'GET_EVENT_HISTORY_TAB_DATA';
export const GET_EVENT_HISTORY_TAB_DATA_SUCCESS = 'GET_EVENT_HISTORY_TAB_DATA_SUCCESS';
export const GET_EVENT_HISTORY_TAB_DATA_FAILURE = 'GET_EVENT_HISTORY_TAB_DATA_FAILURE';
export const CLEAR_EVENT_HISTORY_TAB_DATA = 'CLEAR_EVENT_HISTORY_TAB_DATA';

export const ECA_MODAL_SHOW_EDIT_PROGRAM = 'ECA_MODAL_SHOW_EDIT_PROGRAM';
export const ECA_MODAL_HIDE_EDIT_PROGRAM = 'ECA_MODAL_HIDE_EDIT_PROGRAM';
export const ECA_MODAL_SHOW_EDIT_ACTIVITY = 'ECA_MODAL_SHOW_EDIT_ACTIVITY';
export const ECA_MODAL_HIDE_EDIT_ACTIVITY = 'ECA_MODAL_HIDE_EDIT_ACTIVITY';
export const ECA_MODAL_SHOW_EDIT_EVENT = 'ECA_MODAL_SHOW_EDIT_EVENT';
export const ECA_MODAL_HIDE_EDIT_EVENT = 'ECA_MODAL_HIDE_EDIT_EVENT';
export const ECA_MODAL_SHOW_ACTIVITY_PARTICIPANTS = 'ECA_MODAL_SHOW_ACTIVITY_PARTICIPANTS';
export const ECA_MODAL_HIDE_ACTIVITY_PARTICIPANTS = 'ECA_MODAL_HIDE_ACTIVITY_PARTICIPANTS';
export const ECA_MODAL_SHOW_EVENT_PARTICIPANTS = 'ECA_MODAL_SHOW_EVENT_PARTICIPANTS';
export const ECA_MODAL_HIDE_EVENT_PARTICIPANTS = 'ECA_MODAL_HIDE_EVENT_PARTICIPANTS';

// Modal actions

export const SHOW_CARRIER_MODAL = 'SHOW_CARRIER_MODAL';
export const SHOW_CARRIER_BUS_MODAL = 'SHOW_CARRIER_BUS_MODAL';
export const SHOW_CARRIER_DRIVER_MODAL = 'SHOW_CARRIER_DRIVER_MODAL';
export const SHOW_NOTICE_TEMPLATE_MODAL = 'SHOW_NOTICE_TEMPLATE_MODAL';
export const SHOW_SELECT_BUSES_AND_DRIVERS_MODAL = 'SHOW_SELECT_BUSES_AND_DRIVERS_MODAL';
export const SHOW_SEND_NOTICE_MODAL = 'SHOW_SEND_NOTICE_MODAL';
export const HIDE_CARRIER_MODAL = 'HIDE_CARRIER_MODAL';
export const HIDE_CARRIER_BUS_MODAL = 'HIDE_CARRIER_BUS_MODAL';
export const HIDE_CARRIER_DRIVER_MODAL = 'HIDE_CARRIER_DRIVER_MODAL';
export const HIDE_SELECT_BUSES_AND_DRIVERS_MODAL = 'HIDE_SELECT_BUSES_AND_DRIVERS_MODAL';
export const HIDE_NOTICE_TEMPLATE_MODAL = 'HIDE_NOTICE_TEMPLATE_MODAL';
export const HIDE_SEND_NOTICE_MODAL = 'HIDE_SEND_NOTICE_MODAL';
export const NOTICE_TEMPLATE_MODAL_SUBMITED_SUCCESS = 'NOTICE_TEMPLATE_MODAL_SUBMITED_SUCCESS';
export const NOTICE_TEMPLATE_MODAL_SUBMITED_FAILURE = 'NOTICE_TEMPLATE_MODAL_SUBMITED_FAILURE';

export const TOGGLE_ROUTE_MODAL = 'TOGGLE_ROUTE_MODAL';
export const TOGGLE_COPY_ROUTE_MODAL = 'TOGGLE_COPY_ROUTE_MODAL';
export const ROUTE_MODAL_SUBMITED_SUCCESS = 'ROUTE_MODAL_SUBMITED_SUCCESS';
export const ROUTE_MODAL_SUBMITED_FAILURE = 'ROUTE_MODAL_SUBMITED_FAILURE';

export const SHOW_DEACTIVATE_ACCOUNT_MODAL = 'SHOW_DEACTIVATE_ACCOUNT_MODAL';
export const HIDE_DEACTIVATE_ACCOUNT_MODAL = 'HIDE_DEACTIVATE_ACCOUNT_MODAL';
export const SHOW_DELETE_ACCOUNT_MODAL = 'SHOW_DELETE_ACCOUNT_MODAL';
export const HIDE_DELETE_ACCOUNT_MODAL = 'HIDE_DELETE_ACCOUNT_MODAL';
export const SHOW_ADD_ACCOUNT_MODAL = 'SHOW_ADD_ACCOUNT_MODAL';
export const HIDE_ADD_ACCOUNT_MODAL = 'HIDE_ADD_ACCOUNT_MODAL';
export const SHOW_ADD_STUDENT_FORM = 'SHOW_ADD_STUDENT_FORM';
export const HIDE_ADD_STUDENT_FORM = 'HIDE_ADD_STUDENT_FORM';
export const SHOW_PARENT_STAFF_MODAL = 'SHOW_PARENT_STAFF_MODAL';
export const HIDE_PARENT_STAFF_MODAL = 'HIDE_PARENT_STAFF_MODAL';
export const SHOW_HISTORY_MAP_MODAL = 'SHOW_HISTORY_MAP_MODAL';
export const HIDE_HISTORY_MAP_MODAL = 'HIDE_HISTORY_MAP_MODAL';

export const ERROR_MODAL = 'ERROR_MODAL';
export const HIDE_ERROR_MODAL = 'HIDE_ERROR_MODAL';

// Students Module const

export const CLEAR_STUDENT_ABSENCES_AND_RELATIVES = 'CLEAR_STUDENT_ABSENCES_AND_RELATIVES';
export const CLEAR_STUDENTS_REDUCER = 'CLEAR_STUDENTS_REDUCER';
export const GET_STUDENT_RELATIVES = 'GET_STUDENT_RELATIVES';
export const GET_STUDENT_RELATIVES_FAILURE = 'GET_STUDENT_RELATIVES_FAILURE';
export const GET_STUDENT_RELATIVES_SUCCESS = 'GET_STUDENT_RELATIVES_SUCCESS';

export const SEARCH_PAST_STUDENT_ABSENCES = 'SEARCH_PAST_STUDENT_ABSENCES';
export const SEARCH_PAST_STUDENT_ABSENCES_FAILURE = 'SEARCH_PAST_STUDENT_ABSENCES_FAILURE';
export const SEARCH_PAST_STUDENT_ABSENCES_SUCCESS = 'SEARCH_PAST_STUDENT_ABSENCES_SUCCESS';

export const SEARCH_UPCOMING_STUDENT_ABSENCES = 'SEARCH_UPCOMING_STUDENT_ABSENCES';
export const SEARCH_UPCOMING_STUDENT_ABSENCES_FAILURE = 'SEARCH_UPCOMING_STUDENT_ABSENCES_FAILURE';
export const SEARCH_UPCOMING_STUDENT_ABSENCES_SUCCESS = 'SEARCH_UPCOMING_STUDENT_ABSENCES_SUCCESS';

export const LOAD_MORE_PAST_STUDENTS_ABSENCES = 'LOAD_MORE_PAST_STUDENTS_ABSENCES';
export const LOAD_MORE_PAST_STUDENTS_ABSENCES_FAILURE = 'LOAD_MORE_PAST_STUDENTS_ABSENCES_FAILURE';
export const LOAD_MORE_PAST_STUDENTS_ABSENCES_SUCCESS = 'LOAD_MORE_PAST_STUDENTS_ABSENCES_SUCCESS';

export const SHOW_MORE_PAST_STUDENTS_ABSENCES = 'SHOW_MORE_PAST_STUDENTS_ABSENCES';

export const SEARCH_LOCATION_REQUESTS_HISTORY = 'SEARCH_LOCATION_REQUESTS_HISTORY';
export const SEARCH_LOCATION_REQUESTS_HISTORY_FAILURE = 'SEARCH_LOCATION_REQUESTS_HISTORY_FAILURE';
export const SEARCH_LOCATION_REQUESTS_HISTORY_SUCCESS = 'SEARCH_LOCATION_REQUESTS_HISTORY_SUCCESS';
export const LOAD_MORE_LOCATION_REQUESTS = 'LOAD_MORE_LOCATION_REQUESTS';
export const LOAD_MORE_LOCATION_REQUESTS_FAILURE = 'LOAD_MORE_LOCATION_REQUESTS_FAILURE';
export const LOAD_MORE_LOCATION_REQUESTS_SUCCESS = 'LOAD_MORE_LOCATION_REQUESTS_SUCCESS';
export const GET_INSURANCES = 'GET_INSURANCES';
export const GET_INSURANCES_SUCCESS = 'GET_INSURANCES_SUCCESS';
export const GET_STUDENT_LOCATION = 'GET_STUDENT_LOCATION';
export const GET_STUDENT_LOCATION_SUCCESS = 'GET_STUDENT_LOCATION_SUCCESS';
export const SET_STUDENT_LOCATION_LOADING = 'SET_STUDENT_LOCATION_LOADING';
export const START_STUDENT_LOADING = 'START_STUDENT_LOADING';
export const STOP_STUDENT_LOADING = 'STOP_STUDENT_LOADING';
export const CREATE_ABSENCE = 'CREATE_ABSENCE';
export const CREATE_ABSENCE_SUCCESS = 'CREATE_ABSENCE_SUCCESS';
export const ABSENCE_PENDING_FAILURE = 'ABSENCE_PENDING_FAILURE';
export const TOGGLE_ABSENCE_MODAL = 'TOGGLE_ABSENCE_MODAL';
export const EDIT_ABSENCE = 'EDIT_ABSENCE';
export const EDIT_ABSENCE_SUCCESS = 'EDIT_ABSENCE_SUCCESS';
export const REMOVE_ABSENCE = 'REMOVE_ABSENCE';
export const REMOVE_ABSENCE_SUCCESS = 'REMOVE_ABSENCE_SUCCESS';
export const STOP_ABSENCE = 'STOP_ABSENCE';
export const STOP_ABSENCE_SUCCESS = 'STOP_ABSENCE_SUCCESS';
export const LOAD_ABSENCE_REASONS = 'LOAD_ABSENCE_REASONS';
export const LOAD_ABSENCE_REASONS_SUCCESS = 'LOAD_ABSENCE_REASONS_SUCCESS';

// Carriers Module const

export const CREATE_CARRIER = 'CREATE_CARRIER';
export const CREATE_CARRIER_SUCCESS = 'CREATE_CARRIER_SUCCESS';
export const UPDATE_CARRIER_DETAILS = 'UPDATE_CARRIER_DETAILS';
export const UPDATE_CARRIER_DETAILS_SUCCESS = 'UPDATE_CARRIER_DETAILS_SUCCESS';
export const REMOVE_CARRIER = 'REMOVE_CARRIER';
export const REMOVE_CARRIER_SUCCESS = 'REMOVE_CARRIER_SUCCESS';
export const UPDATE_CARRIER_FAILURE = 'UPDATE_CARRIER_FAILURE';
export const GET_CARRIER_LIST = 'GET_CARRIER_LIST';
export const GET_CARRIER_LIST_SUCCESS = 'GET_CARRIER_LIST_SUCCESS';
export const SET_CARRIER_LIST_LOADING = 'SET_CARRIER_LIST_LOADING';
export const GET_CARRIER_DETAILS = 'GET_CARRIER_DETAILS';
export const GET_CARRIER_DETAILS_ERROR = 'GET_CARRIER_DETAILS_ERROR';
export const GET_CARRIER_DETAILS_SUCCESS = 'GET_CARRIER_DETAILS_SUCCESS';
export const GET_CARRIER_DETAILS_WITH_BUSES_AND_DRIVERS =
  'GET_CARRIER_DETAILS_WITH_BUSES_AND_DRIVERS';
export const SET_CARRIER_DETAILS_LOADING = 'SET_CARRIER_DETAILS_LOADING';
export const RESET_CARRIER_DETAILS = 'RESET_CARRIER_DETAILS';
export const RESET_CARRIER_LIST = 'RESET_CARRIER_LIST';

// Buses Module const

export const CREATE_BUS = 'CREATE_BUS';
export const CREATE_BUS_SUCCESS = 'CREATE_BUS_SUCCESS';
export const UPDATE_BUS = 'UPDATE_BUS';
export const UPDATE_BUS_SUCCESS = 'UPDATE_BUS_SUCCESS';
export const REMOVE_BUS = 'REMOVE_BUS';
export const REMOVE_BUS_SUCCESS = 'REMOVE_BUS_SUCCESS';
export const UPDATE_BUS_FAILURE = 'UPDATE_BUS_FAILURE';
export const GET_BUSES_BY_CARRIER_ID = 'GET_BUSES_BY_CARRIER_ID';
export const GET_BUSES_BY_CARRIER_ID_SUCCESS = 'GET_BUSES_BY_CARRIER_ID_SUCCESS';
export const SET_BUSES_BY_CARRIER_ID_LOADING = 'SET_BUSES_BY_CARRIER_ID_LOADING';
export const GET_BUS_LOCATIONS = 'GET_BUS_LOCATIONS';
export const GET_BUS_LOCATIONS_SUCCESS = 'GET_BUS_LOCATIONS_SUCCESS';
export const GET_AGENDA_BUS_LOCATION = 'GET_AGENDA_BUS_LOCATION';
export const GET_AGENDA_BUS_LOCATION_SUCCESS = 'GET_AGENDA_BUS_LOCATION_SUCCESS';
export const CLEAR_BUS_LOCATIONS = 'CLEAR_BUS_LOCATIONS';
export const GET_CARRIER_BUS_LIST = 'GET_CARRIER_BUS_LIST';
export const GET_BUS_LIST_ERROR = 'GET_BUS_LIST_ERROR';
export const GET_BUS_LIST_SUCCESS = 'GET_BUS_LIST_SUCCESS';
export const SET_BUS_LIST_LOADING = 'SET_BUS_LIST_LOADING';
export const GET_BUS_DETAILS_SUCCESS = 'GET_BUS_DETAILS_SUCCESS';
export const SET_BUS_DETAILS_LOADING = 'SET_BUS_DETAILS_LOADING';

// Drivers Module const

export const CREATE_DRIVER = 'CREATE_DRIVER';
export const CREATE_DRIVER_SUCCESS = 'CREATE_DRIVER_SUCCESS';
export const UPDATE_DRIVER = 'UPDATE_DRIVER';
export const UPDATE_DRIVER_SUCCESS = 'UPDATE_DRIVER_SUCCESS';
export const REMOVE_DRIVER = 'REMOVE_DRIVER';
export const REMOVE_DRIVER_SUCCESS = 'REMOVE_DRIVER_SUCCESS';
export const UPDATE_DRIVER_FAILURE = 'UPDATE_DRIVER_FAILURE';
export const GET_DRIVERS_BY_CARRIER_ID = 'GET_DRIVERS_BY_CARRIER_ID';
export const GET_DRIVERS_BY_CARRIER_ID_SUCCESS = 'GET_DRIVERS_BY_CARRIER_ID_SUCCESS';
export const SET_DRIVERS_BY_CARRIER_ID_LOADING = 'SET_DRIVERS_BY_CARRIER_ID_LOADING';
export const GET_CARRIER_DRIVER_LIST = 'GET_CARRIER_DRIVER_LIST';
export const GET_DRIVER_LIST_ERROR = 'GET_DRIVER_LIST_ERROR';
export const GET_DRIVER_LIST_SUCCESS = 'GET_DRIVER_LIST_SUCCESS';
export const SET_DRIVER_LIST_LOADING = 'SET_DRIVER_LIST_LOADING';
export const GET_DRIVER_DETAILS_SUCCESS = 'GET_DRIVER_DETAILS_SUCCESS';
export const SET_DRIVER_DETAILS_LOADING = 'SET_DRIVER_DETAILS_LOADING';

// WebSockets Notifications

export const WS_SUBSCRIBE = 'WS_SUBSCRIBE';
export const WS_UNSUBSCRIBE = 'WS_UNSUBSCRIBE';
export const WS_MESSAGE_RECEIVED = 'WS_MESSAGE_RECEIVED';
export const WS_START_CHECK_CONNECTION = 'WS_START_CHECK_CONNECTION';
export const WS_STOP_CHECK_CONNECTION = 'WS_STOP_CHECK_CONNECTION';
export const WS_FETCH_DATA = 'WS_FETCH_DATA';
export const WS_SUBSCRIBE_EVENT = 'WS_SUBSCRIBE_EVENT';
export const WS_UNSUBSCRIBE_EVENT = 'WS_UNSUBSCRIBE_EVENT';
// Agenda module consts

export const GET_AGENDA_LIST = 'GET_AGENDA_LIST';
export const GET_AGENDA_LIST_SUCCESS = 'GET_AGENDA_LIST_SUCCESS';
export const SET_AGENDA_LIST_LOADING = 'SET_AGENDA_LIST_LOADING';
export const GET_AGENDA_DETAILS = 'GET_AGENDA_DETAILS';
export const GET_AGENDA_DETAILS_SUCCESS = 'GET_AGENDA_DETAILS_SUCCESS';
export const SET_AGENDA_DETAILS_LOADING = 'SET_AGENDA_DETAILS_LOADING';
export const CLEAR_AGENDA_REDUCER = 'CLEAR_AGENDA_REDUCER';

// Contacts module consts

export const SET_CONTACTS_LOADING = 'SET_CONTACTS_LOADING';
export const GET_EMERGENCY_CONTACTS = 'GET_EMERGENCY_CONTACTS';
export const GET_EMERGENCY_CONTACTS_SUCCESS = 'GET_EMERGENCY_CONTACTS_SUCCESS';
export const CLEAR_EMERGENCY_CONTACTS_REDUCER = 'CLEAR_EMERGENCY_CONTACTS_REDUCER';

export const CREATE_PUPIL_CONTACTS = 'CREATE_PUPIL_CONTACTS';
export const LINK_PUPIL_CONTACT = 'LINK_PUPIL_CONTACT';
export const UPDATE_PUPIL_CONTACT = 'UPDATE_PUPIL_CONTACT';
export const DELETE_PUPIL_CONTACT = 'DELETE_PUPIL_CONTACT';

// Sos button

export const SEND_SOS_SIGNAL = 'SEND_SOS_SIGNAL';
export const START_SOS_SIGNAL_TIMER = 'START_SOS_SIGNAL_TIMER';
export const SAVE_NEW_TIMER_COUNT_VALUE = 'SAVE_NEW_TIMER_COUNT_VALUE';
export const SEND_SIGNAL_ABORT = ' SEND_SIGNAL_ABORT';
export const CHECK_PASSWORD = ' CHECK_PASSWORD';
export const CHECK_PASSWORD_ERROR = ' CHECK_PASSWORD_ERROR';
export const SOS_SIGNAL_SUCCESS = 'SOS_SIGNAL_SUCCESS';
export const SAVE_SOS_COORDS = 'SAVE_SOS_COORDS';
export const GET_ACTIVE_SIGNALS = 'GET_ACTIVE_SIGNALS';
export const GET_ACTIVE_SIGNALS_SUCCESS = 'GET_ACTIVE_SIGNALS_SUCCESS';
export const SOS_ACTION_FORBIDDEN = 'SOS_ACTION_FORBIDDEN';
export const CLEAR_SOS_ACTION_FORBIDDEN = 'CLEAR_SOS_ACTION_FORBIDDEN';

// Users module consts

export const CLEAR_USER_BY_ID = 'CLEAR_USER_BY_ID';
export const CLEAR_USERS = 'CLEAR_USERS';
export const GET_USER_BY_ID = 'GET_USER_BY_ID';
export const GET_USER_BY_ID_SUCCESS = 'GET_USER_BY_ID_SUCCESS';
export const SEARCH_USERS = 'SEARCH_USERS';
export const SEARCH_USERS_SUCCESS = 'SEARCH_USERS_SUCCESS';
export const SEARCH_USERS_FORM = 'SEARCH_USERS_FORM';
export const SEARCH_USERS_FORM_SUCCESS = 'SEARCH_USERS_FORM_SUCCESS';
export const SEARCH_USERS_FORM_ERROR = 'SEARCH_USERS_FORM_ERROR';
export const SET_USERS_LOADING = 'SET_USERS_LOADING';
export const DEACTIVATE_USER = 'DEACTIVATE_USER';
export const DEACTIVATE_USER_SUCCESS = 'DEACTIVATE_USER_SUCCESS';
export const DEACTIVATE_USER_ERROR = 'DEACTIVATE_USER_ERROR';
export const ACTIVATE_USER = 'ACTIVATE_USER';
export const ACTIVATE_USER_SUCCESS = 'ACTIVATE_USER_SUCCESS';
export const ACTIVATE_USER_ERROR = 'ACTIVATE_USER_ERROR';
export const DELETE_USER_BY_ID = 'DELETE_USER_BY_ID';
export const DELETE_USER_BY_ID_SUCCESS = 'DELETE_USER_BY_ID_SUCCESS';
export const DELETE_USER_BY_ID_ERROR = 'DELETE_USER_BY_ID_ERROR';
export const CREATE_SYSTEM_USER_ON_STUDENT = 'CREATE_SYSTEM_USER_ON_STUDENT';
export const CREATE_SYSTEM_USER_ON_CONTACT = 'CREATE_SYSTEM_USER_ON_CONTACT';
export const GET_STUDENT_INFO = 'GET_STUDENT_INFO';
export const GET_STUDENT_INFO_SUCCESS = 'GET_STUDENT_INFO_SUCCESS';
export const GET_STUDENT_INFO_ERROR = 'GET_STUDENT_INFO_ERROR';
export const CREATE_STUDENT = 'CREATE_STUDENT';
export const CREATE_STUDENT_SUCCESS = 'CREATE_STUDENT_SUCCESS';
export const CREATE_STUDENT_ERROR = 'CREATE_STUDENT_ERROR';
export const UPDATE_STUDENT = 'UPDATE_STUDENT';
export const UPDATE_STUDENT_SUCCESS = 'UPDATE_STUDENT_SUCCESS';
export const UPDATE_STUDENT_ERROR = 'UPDATE_STUDENT_ERROR';
export const GET_SYSTEM_USER = 'GET_SYSTEM_USER';
export const UPDATE_SYSTEM_USER_ON_STUDENT = 'UPDATE_SYSTEM_USER_ON_STUDENT';
export const UPDATE_SYSTEM_USER_ON_CONTACT = 'UPDATE_SYSTEM_USER_ON_CONTACT';

// Call Session

export const START_CALL_SESSION = 'START_CALL_SESSION';
export const START_CALL_SESSION_SUCCESS = 'START_CALL_SESSION_SUCCESS';
export const START_CALL_SESSION_ERROR = 'START_CALL_SESSION_ERROR';
export const STOP_CALL_SESSION = 'STOP_CALL_SESSION';
export const STOP_CALL_SESSION_SUCCESS = 'STOP_CALL_SESSION_SUCCESS';
export const STOP_CALL_SESSION_ERROR = 'STOP_CALL_SESSION_ERROR';

// Statistics

export const GET_STATISTICS = 'GET_STATISTICS';
export const GET_STATISTICS_SUCCESS = 'GET_STATISTICS_SUCCESS';
export const GET_STATISTICS_CATEGORIES_SUCCESS = 'GET_STATISTICS_CATEGORIES_SUCCESS';
export const GET_STATISTICS_CATEGORIES = 'GET_STATISTICS_CATEGORIES';
export const CLEAR_STATISTICS_REDUCER = 'CLEAR_STATISTICS_REDUCER';

// Report

export const GET_REPORT_PENDING = 'GET_REPORT_PENDING';
export const GET_HISTORY_REPORT_LIST = 'GET_HISTORY_REPORT_LIST';
export const GET_HISTORY_REPORTS_LIST_SUCCESS = 'GET_HISTORY_REPORTS_LIST_SUCCESS';
export const GET_REPORT_SUCCESS = 'GET_REPORT_SUCCESS';
export const GET_REPORT_ERROR = 'GET_REPORT_ERROR';
export const TOGGLE_REPORT_MODAL = 'TOGGLE_REPORT_MODAL';
export const CANCEL_REPORT = 'CANCEL_REPORT';
export const GET_REPORT_FINISH = 'GET_REPORT_FINISH';
export const REPORT_IN_A_QUEUE = 'REPORT_IN_A_QUEUE';
export const CLOSE_REPORT_MODAL = 'CLOSE_REPORT_MODAL';

// Import/Export/Extract Data

export const IMPORT_USER_DATA = 'IMPORT_USER_DATA';
export const IMPORT_USER_DATA_SUCCESS = 'IMPORT_USER_DATA_SUCCESS';
export const IMPORT_USER_DATA_ERROR = 'IMPORT_USER_DATA_ERROR';
export const IMPORT_ROUTES = 'IMPORT_ROUTES';
export const IMPORT_ROUTES_SUCCESS = 'IMPORT_ROUTES_SUCCESS';
export const IMPORT_ROUTES_ERROR = 'IMPORT_ROUTES_ERROR';
export const UPLOAD_USERS_FILE = 'UPLOAD_USERS_FILE';
export const UPLOAD_USER_FILE_SUCCESS = 'UPLOAD_USER_FILE_SUCCESS';
export const UPLOAD_ROUTES_FILE = 'UPLOAD_ROUTES_FILE';
export const UPLOAD_ROUTES_FILE_SUCCESS = 'UPLOAD_ROUTES_FILE_SUCCESS';

export const EXTRACT_USER_DATA = 'EXTRACT_USER_DATA';
export const EXTRACT_USER_DATA_SUCCESS = 'EXTRACT_USER_DATA_SUCCESS';
export const EXTRACT_USER_DATA_ERROR = 'EXTRACT_USER_DATA_ERROR';

export const EXTRACT_ROUTES = 'EXTRACT_ROUTES';
export const EXTRACT_ROUTES_SUCCESS = 'EXTRACT_ROUTES_SUCCESS';
export const EXTRACT_ROUTES_ERROR = 'EXTRACT_ROUTES_ERROR';

export const EXPORT_USER_DATA = 'EXPORT_USER_DATA';
export const EXPORT_USER_DATA_SUCCESS = 'EXPORT_USER_DATA_SUCCESS';
export const EXPORT_USER_DATA_ERROR = 'EXPORT_USER_DATA_ERROR';

export const EXPORT_ROUTES = 'EXPORT_ROUTES';
export const EXPORT_ROUTES_SUCCESS = 'EXPORT_ROUTES_SUCCESS';
export const EXPORT_ROUTES_ERROR = 'EXPORT_ROUTES_ERROR';
export const GET_ROUTES_EXPORT_FORMATS = 'GET_ROUTES_EXPORT_FORMATS';
export const GET_ROUTES_EXPORT_FORMATS_SUCCESS = 'GET_ROUTES_EXPORT_FORMATS_SUCCESS';
export const GET_ROUTES_EXPORT_FORMATS_ERROR = 'GET_ROUTES_EXPORT_FORMATS_ERROR';

export const IMPORT_ECA_EVENTS = 'IMPORT_ECA_EVENTS';
export const IMPORT_ECA_EVENTS_SUCCESS = 'IMPORT_ECA_EVENTS_SUCCESS';
export const IMPORT_ECA_EVENTS_ERROR = 'IMPORT_ECA_EVENTS_ERROR';

export const UPLOAD_ECA_EVENTS_FILE = 'UPLOAD_ECA_EVENTS_FILE';
export const UPLOAD_ECA_EVENTS_FILE_SUCCESS = 'UPLOAD_ECA_EVENTS_FILE_SUCCESS';

export const EXTRACT_ECA_EVENTS = 'EXTRACT_ECA_EVENTS';
export const EXTRACT_ECA_EVENTS_SUCCESS = 'EXTRACT_ECA_EVENTS_SUCCESS';
export const EXTRACT_ECA_EVENTS_ERROR = 'EXTRACT_ECA_EVENTS_ERROR';

export const EXPORT_ECA_EVENTS = 'EXPORT_ECA_EVENTS';
export const EXPORT_ECA_EVENTS_SUCCESS = 'EXPORT_ECA_EVENTS_SUCCESS';
export const EXPORT_ECA_EVENTS_ERROR = 'EXPORT_ECA_EVENTS_ERROR';

export const GET_SCHOOL_BY_TENANT = 'GET_SCHOOL_BY_TENANT';
export const GET_SCHOOL_BY_TENANT_SUCCESS = 'GET_SCHOOL_BY_TENANT_SUCCESS';
export const GET_SCHOOL_BY_TENANT_ERROR = 'GET_SCHOOL_BY_TENANT_ERROR';

export const GET_ROUTES_FOR_PROFILE = 'GET_ROUTES_FOR_PROFILE';
export const GET_ROUTES_FOR_PROFILE_SUCCESS = 'GET_ROUTES_FOR_PROFILE_SUCCESS';
export const GET_ROUTES_FOR_PROFILE_ERROR = 'GET_ROUTES_FOR_PROFILE_ERROR';

export const UPLOAD_AVATAR = 'UPLOAD_AVATAR';
export const UPLOAD_AVATAR_SUCCESS = 'UPLOAD_AVATAR_SUCCESS';
export const UPLOAD_AVATAR_ERROR = 'UPLOAD_AVATAR_ERROR';

// Diversion — active-diversion list (TM status board on Routes overview page)
export const GET_ACTIVE_DIVERSIONS_REQUEST = 'GET_ACTIVE_DIVERSIONS_REQUEST';
export const GET_ACTIVE_DIVERSIONS_SUCCESS = 'GET_ACTIVE_DIVERSIONS_SUCCESS';
export const GET_ACTIVE_DIVERSIONS_FAILURE = 'GET_ACTIVE_DIVERSIONS_FAILURE';

// Diversion — composer success-handler hook. Task 11 wires the consumer.
// Added inline in task 06 per Ambiguity #8 default; task 03 will absorb if merging later.
export const FOCUS_DIVERSIONS_TAB_REQUEST = 'FOCUS_DIVERSIONS_TAB_REQUEST';

// Dev overlay — fixture overlay system (task 02). Dev-only; the saga is gated
// on process.env.NODE_ENV === 'development' so this action never fires in prod.
export const SET_DEV_OVERLAY_ACTIVE_KEYS = 'SET_DEV_OVERLAY_ACTIVE_KEYS';
